import script from "./DeletePaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./DeletePaymentForm.vue?vue&type=style&index=0&id=093f1abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093f1abe"]])

export default __exports__